module.exports = __webpack_public_path__ + "static/img/taras.1f12d21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sources/taras.jpg
// module id = rEsJ
// module chunks = 1